/** Чистая логика жеста свайпа (пороги — как в старой версии). */

export const SWIPE_THRESHOLD = 80; // px: дальше — голос
export const GLOW_THRESHOLD = 40; // px: подсветка края
export const TAP_THRESHOLD = 8; // px: меньше — это тап (переворот карточки)
export const LEAVE_MS = 300; // длительность вылета карточки

export type Release = "like" | "dislike" | "tap" | "reset";

export function classifyRelease(dx: number): Release {
  if (Math.abs(dx) < TAP_THRESHOLD) return "tap";
  if (dx > SWIPE_THRESHOLD) return "like";
  if (dx < -SWIPE_THRESHOLD) return "dislike";
  return "reset";
}

export function glowShadow(dx: number): string | undefined {
  if (dx > GLOW_THRESHOLD) return "0 0 30px rgba(0,255,0,0.6)";
  if (dx < -GLOW_THRESHOLD) return "0 0 30px rgba(255,0,0,0.6)";
  return undefined;
}

export function dragTransform(dx: number): string | undefined {
  return dx === 0 ? undefined : `translateX(${dx}px) rotate(${dx * 0.05}deg)`;
}
